import classNames from "classnames";
import React, { type PropsWithChildren } from "react";

export interface PreviewPanelDetailRowProps {
  labelTop?: string
  subLabelTop?: string
  grid?: boolean
  noGap?: boolean
}

export const PreviewPanelDetailRow = (props: PropsWithChildren<PreviewPanelDetailRowProps>) => {
  const { labelTop, subLabelTop, grid, noGap } = props;

  return <div className={classNames("flex-column", {
    "gap-small": !noGap
  })}>
    {labelTop && <div className="body-text-regular s1_gray">{labelTop}</div>}
    {subLabelTop && <div className="s1_small s1_gray">{subLabelTop}</div>}
    <div className={grid ? "preview-panel-detail-row-grid" : ""}>{props.children}</div>
  </div>;
};